import { CLASS_ASIDE_PANEL } from '../../constants';
import { getMessages } from 'app/store/constants';

export const CLASS_ASIDE_PANEL_CL_BUTTON = CLASS_ASIDE_PANEL + '__clbutton';
export const LINK_CARD_BUTTON_TEXT = getMessages().getText('card_link.button');
